export default __webpack_public_path__ + "static/media/bg.ae949040.jpg";